/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
    
    // Remove empty P tags created by WP inside of Accordion and Orbit
    $('.accordion p:empty, .orbit p:empty').remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
            $(this).wrap("<div class='widescreen responsive-embed'/>");
        } else {
            $(this).wrap("<div class='responsive-embed'/>");
        }
    });

    //show more button
    $("button.filterSport").click(function(event) {
        event.preventDefault();
        $(".filter-sport").slideToggle("slow");
    
        var $this = jQuery(this);
        $this.toggleClass("open");
    
        // Check if the button is inside a div with class 'product-catalog-gallery'
        if ($this.closest(".product-catalog-gallery").length > 0) {
            if ($this.hasClass("open")) {
                $this.css("margin-bottom", "0");
            } else {
                $this.css("margin-bottom", "20px");
            }
        } 
        // No margin-bottom change if inside 'design-template-gallery'
    });

      $('.wp-block-gallery .wp-block-image').each(function() {
        var $figure = $(this);
        var $link = $figure.find('a');
        var $caption = $figure.find('.wp-element-caption');
    
        if ($link.length && $caption.length) {
          $link.append($caption);  
        }
      });

    //  home page hover animation
    // let heroCon = $('.home-hero-con'),
    //  spirit = $('.spirit-hero-con'),
    //  spirita = $('.spirit-hero-con a'),
    //  spiritText = $('.spirit-wear-hero-txt'),
    //  uniforms = $('.uniform-hero-con'),
    //  uniformsa = $('.uniform-hero-con a'),
    //  uniformText = $('.uniforms-hero-txt');
    // spirit.mouseover(() => heroCon.addClass('spirit-hover'));
    // spirit.mouseout(() => heroCon.removeClass('spirit-hover'));
    // spirita.focus(() => heroCon.addClass('spirit-hover'));
    // spirita.blur(() => heroCon.removeClass('spirit-hover'));
    // uniforms.mouseover(() => heroCon.addClass('uniform-hover'));
    // uniforms.mouseout(() => heroCon.removeClass('uniform-hover'));
    // uniformsa.focus(() => heroCon.addClass('uniform-hover'));
    // uniformsa.blur(() => heroCon.removeClass('uniform-hover'));
    
    function setupHoverEffects(selector, hoverClass) {
        const $container = $(selector);
        const $links = $(`${selector} a`);
        const $hero = $('.home-hero-con');
     
        $container.add($links)
            .on('mouseover focus', () => $hero.addClass(hoverClass))
            .on('mouseout blur', () => $hero.removeClass(hoverClass));
     }
     
     setupHoverEffects('.spirit-hero-con', 'spirit-hover');
     setupHoverEffects('.uniform-hero-con', 'uniform-hover');

    // Contact Team Up HQ slide in form animation
    let contactBtn = $('.contact-hq-btn'),
        formCon = $('.contact-hq-form-slider'),
        closeForm = $('.close-contacthq-btn'),
        focusedElementBeforeSlider = contactBtn;
    formCon.attr('aria-hidden', 'true');
    $('.slide-out-form').siblings().hide();
    closeForm.hide();
    contactBtn.click(function(e) {
        e.preventDefault();
        slideOpenForm();
    });
    closeForm.click(function(e) {
        e.preventDefault();
        slideCloseForm();
    });
    if ($('.gform_wrapper').hasClass('gform_validation_error')) {
        slideOpenForm();
    }

    function slideOpenForm(e) {
        // Trap tab key in form
        if (document.activeElement == document.querySelector('body')){
            focusedElementBeforeSlider = contactBtn;
        } else {
            focusedElementBeforeSlider = document.activeElement;
        }
        $('.slide-out-form').siblings().show();
        closeForm.show();
        formCon.on('keydown', trapTabKey);
        let focusableElements = formCon.find('a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]');
        focusableElements = Array.prototype.slice.call(focusableElements);
        let firstTabStop = focusableElements[0];
        let lastTabStop = focusableElements[focusableElements.length - 1];
        formCon.attr('aria-hidden', 'false');
        setTimeout(function(){
            formCon.css('left', '0');
        }, 100);
        firstTabStop.focus();
        function trapTabKey(e) {
            // Check for TAB key press
            if (e.keyCode === 9) {
              // SHIFT + TAB
              if (e.shiftKey) {
                if (document.activeElement === firstTabStop) {
                  e.preventDefault();
                  lastTabStop.focus();
                }
        
              // TAB
              } else {
                if (document.activeElement === lastTabStop) {
                  e.preventDefault();
                  firstTabStop.focus();
                }
              }
            }
        
            // ESCAPE
            if (e.keyCode === 27) {
                slideCloseForm();
            }
        }
    }
    function slideCloseForm(e) {
        formCon.css('left', '-100%');
        setTimeout(function(){
            formCon.attr('aria-hidden', 'true');
            $('.slide-out-form').siblings().hide();
            closeForm.hide();
        }, 1000);
        focusedElementBeforeSlider.focus();
    }

    // flip cards tabbing
    $('.flip-card').attr('tabIndex', '0');

    // select form field placeholder text coloring
    $('.thrive25-form select').css('color','#666');
    $('.thrive25-form select').change(function() {
        var current = $(this).val();
        if (current != 'null') {
            $(this).css('color','black');
        } else {
            $(this).css('color','#666');
        }
    });

    // Check if we're on /payment-history/
  if ( window.location.pathname === '/payment-history/' ) {
    // Function to toggle overflow based on width
    function toggleOverflow() {
      if ( $(window).width() < 1024 ) {
        $('.entry-content').css('overflow-x', 'scroll');
      } else {
        // Remove it when width is >=1024 if needed
        $('.entry-content').css('overflow-x', '');
      }
    }

    // Run on load
    toggleOverflow();

    // Run on resize
    $(window).on('resize', function() {
      toggleOverflow();
    });
  }
}); 


// document.addEventListener('DOMContentLoaded', function () {
//  const galleryContainer = document.querySelector('.wp-block-gallery');
  
//  if (!galleryContainer) {
//    return;
//  }
  
//  const filterCheckboxes = document.querySelectorAll('.filter-controls input[type="checkbox"]');
//  const images = document.querySelectorAll('.wp-block-gallery .wp-block-image');
  
//  function filterImages() {
//    const activeFilters = Array.from(filterCheckboxes)
//      .filter(checkbox => checkbox.checked)
//      .map(checkbox => checkbox.getAttribute('data-filter'));
  
//    if (activeFilters.length === 0) {
//      // Show all images if no filters are selected
//      images.forEach(image => {
//        image.style.display = 'block';
//      });
//    } else {
//      // Filter images based on selected filters
//      images.forEach(image => {
//        const imageFilters = Array.from(image.classList);
//        if (activeFilters.some(filter => imageFilters.includes(filter))) {
//          image.style.display = 'block';
//        } else {
//          image.style.display = 'none';
//        }
//      });
//    }
  
//    // After filtering, initialize Masonry layout
//    if (typeof Masonry === 'function') {
//      var msnry = new Masonry(galleryContainer, {
//        itemSelector: '.wp-block-image',
//        columnWidth: '.wp-block-image',
//        percentPosition: true,
//        gutter: 20
//      });
//    }
//  }
  
//  // Add event listeners to checkboxes
//  filterCheckboxes.forEach(checkbox => {
//    checkbox.addEventListener('change', filterImages);
//  });
  
//  // Initial filter application on page load
//  filterImages();  
//  setTimeout(filterImages, 1000);
//   });

document.addEventListener('DOMContentLoaded', function () {
    const galleryContainer = document.querySelector('.product-gallery');
  
    if (!galleryContainer) {
      return;
    }
  
    const filterCheckboxes = document.querySelectorAll('.filter-controls input[type="checkbox"]');
    const images = document.querySelectorAll('.wp-block-gallery .wp-block-image');

    // Initialize Masonry once, then update layout as needed
    let msnry;
    if (typeof Masonry === 'function') {
        msnry = new Masonry(galleryContainer, {
            itemSelector: '.wp-block-image',
            columnWidth: '.wp-block-image',
            percentPosition: true,
            gutter: 20
        });
    }
  
    function filterImages() {
      const activeFilters = Array.from(filterCheckboxes)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.getAttribute('data-filter'));
  
      if (activeFilters.length === 0) {
        // Show all images if no filters are selected
        images.forEach(image => {
          image.style.display = 'block';
        });
      } else {
        // Filter images based on selected filters
        images.forEach(image => {
          const imageFilters = Array.from(image.classList);
          if (activeFilters.some(filter => imageFilters.includes(filter))) {
            image.style.display = 'block';
          } else {
            image.style.display = 'none';
          }
        });
      }

      // Trigger Masonry layout update after filtering with a slight delay
      if (msnry) {
        setTimeout(() => {
            msnry.layout();
        }, 100); // Adjust delay as needed
      }
    }
  
    // Add event listeners to checkboxes
    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', filterImages);
    });
  
    // Initial filter application on page load
    filterImages();  
    //setTimeout(filterImages, 1000);
});

document.addEventListener('DOMContentLoaded', function () {
    const galleryContainer = document.querySelector('.design-gallery');
  
    if (!galleryContainer) {
      return;
    }
  
    const filterCheckboxes = document.querySelectorAll('.filter-controls input[type="checkbox"]');
    const images = document.querySelectorAll('.wp-block-gallery .wp-block-image');

    galleryContainer.style.display = 'flex';
    galleryContainer.style.flexWrap = 'wrap';

    function filterImages() {
      const activeFilters = Array.from(filterCheckboxes)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.getAttribute('data-filter'));
  
      if (activeFilters.length === 0) {
        // Show all images if no filters are selected
        images.forEach(image => {
          image.style.display = 'block';
        });
      } else {
        // Filter images based on selected filters
        images.forEach(image => {
          const imageFilters = Array.from(image.classList);
          if (activeFilters.some(filter => imageFilters.includes(filter))) {
            image.style.display = 'block';
          } else {
            image.style.display = 'none';
          }
        });
      }

      // Reorder images using CSS Grid or Flexbox, no need for layout update
    }
  
    // Add event listeners to checkboxes
    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', filterImages);
    });
  
    // Initial filter application on page load
    filterImages();  
});

// full content catalog filters
document.addEventListener('DOMContentLoaded', function () {
    let filterbtns = document.querySelectorAll('.filter-controls input');
    let filtercards = document.querySelectorAll('.filter-cards-con > .kt-row-column-wrap > div ');

    
    filterbtns.forEach(filterbtn => {
        filterbtn.addEventListener('click', function(){
            // Get all checked filters
            const checkedFilters = Array.from(filterbtns)
                .filter(btn => btn.checked)
                .map(btn => btn.getAttribute('data-filter'));

            // Show/hide cards based on filters
            filtercards.forEach(card => {
                if (checkedFilters.length === 0) {
                    // If no filters are selected, show all cards
                    card.style.display = '';
                } else {
                    // Check if card has any of the selected filters
                    const hasMatch = checkedFilters.some(filter => 
                        card.classList.contains(filter)
                    );
                    
                    // Show card if it matches any selected filter, hide if it doesn't
                    card.style.display = hasMatch ? '' : 'none';
                }
            });
        });
    });
});

// Thrive in 25 conference form attendee and cost calculations
document.addEventListener('DOMContentLoaded', function() {
    // Get all select fields with parent class 'attending-event'
    const attendingSelects = document.querySelectorAll('.attending-event select');
    
    // Set up the display elements
    const eventAttendeeTotal = document.getElementById('event-attendee-total');
    const banquetAttendeeTotal = document.getElementById('banquet-attendee-total');
    const vendorAttendeeTotal = document.getElementById('vendor-attendee-total');
    const eventCostTotal = document.querySelector('.thrive25-form #event-cost-total') || document.getElementById('event-cost-total');
    const banquetCostTotal = document.getElementById('banquet-cost-total');
    const vendorCostTotal = document.getElementById('vendor-cost-total');
    const finalTotal = document.getElementById('final-total');

    // Hidden field for total cost
    const totalHidden = document.getElementById('input_7_60') || document.getElementById('input_10_60');

    // Fixed pricing
    //const EVENT_PRICE = 1; // Test price
    const EVENT_PRICE = 300;
    const BANQUET_PRICE = 100;
    const VENDOR_PRICE = 550;
    let DISCOUNT = eventCostTotal === document.querySelector('.thrive25-form #event-cost-total') ? 0.2 : 0.15; // put discount percent as a decimal number

    
    // Function to calculate and update totals
    function updateTotals() {
      let eventCount = 0;
      let banquetCount = 0;
      let vendorCount = 0;
      
      // Loop through all select fields
      attendingSelects.forEach(select => {
        // Check if parent element is visible
        const parentElement = select.closest('.attending-event');
        const isVisible = parentElement && window.getComputedStyle(parentElement).display !== 'none';
        
        // Only count if the element is visible
        if (isVisible) {
          const selectedValue = select.value;
          
          if (selectedValue.includes('Entire Event')) {
            eventCount++;
          } else if (selectedValue.includes('Awards Banquet Only')) {
            banquetCount++;
          } else if (selectedValue.includes('Vendor')) {
            vendorCount++;
          }
        }
      });
      
      // Calculate costs using fixed prices
      const eventCost = eventCount * (EVENT_PRICE - (EVENT_PRICE * DISCOUNT));
      const banquetCost = banquetCount * BANQUET_PRICE;
      const vendorCost = vendorCount * VENDOR_PRICE;
      
      // Update the display
      eventAttendeeTotal.textContent = eventCount;
      banquetAttendeeTotal.textContent = banquetCount;
      vendorAttendeeTotal.textContent = vendorCount;
      eventCostTotal.textContent = eventCost;
      banquetCostTotal.textContent = banquetCost;
      vendorCostTotal.textContent = vendorCost;
      finalTotal.textContent = eventCost + banquetCost + vendorCost;

      // Update total hidden field
      totalHidden.setAttribute('value', eventCost + banquetCost + vendorCost);
    }
    
    // Add event listeners to all select fields
    attendingSelects.forEach(select => {
      select.addEventListener('change', updateTotals);
    });
    
    // Add a mutation observer to detect style changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
          updateTotals();
        }
      });
    });
    
    // Observe all parent elements with .attending-event class
    document.querySelectorAll('.attending-event').forEach(element => {
      observer.observe(element, { attributes: true });
    });
    
    // Initial calculation
    updateTotals();
  });